import {PaletteMode} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Chat from "./components/Chat";
import AppAppBar from './components/AppAppBar';
import getLPTheme from './getLPTheme';
import {useState} from "react";
import Container from "@mui/material/Container";

import SnackbarControls from "./components/SnackbarControls";
import Copyright from "./components/copyright";
import Video from "./components/Video";


export const APP_NAME: string = document.getElementById("app_name")!.innerText;


function App() {
    const last_theme: PaletteMode = localStorage.getItem("theme") === "light" ? "light" : "dark";
    const [mode, setMode] = useState<PaletteMode>(last_theme)
    const LPTheme = createTheme(getLPTheme(mode));
    const [story, setStory] = useState([])
    const [name, setName] = useState("")
    const [Bar, notif] = SnackbarControls();

    const toggleColorMode = () => {
        setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    return (
        <ThemeProvider theme={LPTheme}>
            <Container sx={{display: "flex", alignItems: "flex-end", justifyContent: "center", height: "95vh"}}>
                {Bar}
                <CssBaseline/>
                <AppAppBar mode={mode} toggleColorMode={toggleColorMode} storyConf={[story, setStory]}
                           usernameConf={[name, setName]} notif={notif}/>
                <Chat notif={notif}/>
                <div style={{position: "absolute", left: 0, bottom: 0, padding: "20px"}}>
                    <Video/>
                </div>
            </Container>
            <div style={{
                position: "fixed",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100vw"
            }}>
                <Copyright/>
            </div>
        </ThemeProvider>
    );
}

export default App;
